import { Plus, User, Users } from "lucide-react";
import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import TopNavbar from "../../components/AdminPortal/TopNavbar";
import { useSidebar } from "../../context/SidebarContext";
import "../../global.css";
import Announcement from "../../components/Announcement";
import OfficeNoticeBoard from "../../components/OfficeNoticeBoard";
import TeamMessaging from "../../components/TeamMessaging";
import {useAuth} from "../../context/AuthContext";
import NetworkList from "../../components/AdminPortal/NetworkList";
import DashboardTab from "./DashboardTab";
import AddStaffForm from "../../pages/AdminPortal/Addstaff";
import AffiliatedNew from "../../pages/AdminPortal/AffiliatedNew";
const Dashboard = () => {
  const { sidebarExpanded, isMobile } = useSidebar();
  const {user} = useAuth();
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("dashboard");
  const [showAddStaff, setShowAddStaff] = useState(false);
  const [showAddAffiliate, setShowAddAffiliate] = useState(false);

  useEffect(() => {
    const hasLoggedIn = sessionStorage.getItem("justLoggedIn");
    if (hasLoggedIn === "true") {
      toast.success("Login successful");
      sessionStorage.removeItem("justLoggedIn");
    }
  }, []);
  return (
    <div
      className="min-h-screen bg-black text-white   mt-12"
      style={{
        marginLeft: isMobile ? "0" : sidebarExpanded ? "200px" : "60px",
        width: isMobile
          ? "100%"
          : `calc(100% - ${sidebarExpanded ? "200px" : "60px"})`,
      }}
    >
      <TopNavbar />
      <div className="p-4 md:p-6">

        <div className="tab-strip-border overflow-x-auto scrollbar-hide">
          <div className="flex">
            <button
              onClick={() => setActiveTab("dashboard")}
              className={`tab-button ${
                activeTab === "dashboard"
                  ? "active-tab-border"
                  : "inactive-tab"
              }`}
            >
              Dashboard
            </button>
            <button
              onClick={() => setActiveTab("Announcement")}
              className={`tab-button ${
                activeTab === "Announcement"
                  ? "active-tab-border" // Apply the active border class
                  : "inactive-tab" // Apply inactive tab class
              }`}
            >
              Announcement
            </button>
            <button
              onClick={() => setActiveTab("TeamMessaging")}
              className={`tab-button ${
                activeTab === "TeamMessaging"
                  ? "active-tab-border"
                  : "inactive-tab"
              }`}
            >
              Team Messaging
            </button>
            <button
              onClick={() => setActiveTab("OfficeNoticeBoard")}
              className={`tab-button ${
                activeTab === "OfficeNoticeBoard"
                  ? "active-tab-border" // Apply the active border class
                  : "inactive-tab" // Apply inactive tab class
              }`}
            >
              Office Notice Board
            </button>
            <button
              onClick={() => setActiveTab("network-list")}
              className={`tab-button ${
                activeTab === "network-list"
                  ? "active-tab-border" // Apply the active border class
                  : "inactive-tab" // Apply inactive tab class
              }`}
            >
              Network List
            </button>

          </div>
        </div>

        <div className="flex justify-end  gap-2 mt-2">

         
                    <button
            onClick={() => setShowAddAffiliate(true)}
            className="bg-yellow-400 hover:bg-yellow-300 text-black text-sm font-semibold px-4 py-2 rounded flex items-center gap-2"
          >
            <Users size={16} /> Add Affiliate Partner
          </button>
        </div>

        
      </div>
      {showAddStaff ? (
        <div className="absolute top-0 left-0 w-full h-full bg-black z-10">
          <AddStaffForm onBack={() => setShowAddStaff(false)} />
        </div>
      ) : showAddAffiliate ? (
        <div className="absolute top-0 left-0 w-full h-full p-3 pl-5 bg-black z-10">
          <AffiliatedNew onBack={() => setShowAddAffiliate(false)} />
        </div>
      ) : activeTab === "dashboard" ? (
         <DashboardTab />
        ) : activeTab === "Announcement" ? (
          <Announcement />
        ) : activeTab === "OfficeNoticeBoard" ? (
          <OfficeNoticeBoard />
        ) : activeTab === "TeamMessaging" ? (
          <TeamMessaging />
        ) : activeTab === "network-list" ? (
          <NetworkList  Id={user?.id}/>
        ) : null}
    </div>
  );
};

export default Dashboard;
